import { Suspense } from 'react';
import classnames from 'classnames';

import { BaseLoaderSpinner } from '..';
import icons from '../Icons/Icons';
import './BaseIcon.scss';

export const BaseIcon = (props) => {
  const classes = classnames('base-icon', props.className, {
    'base-icon--small': props.small,
    'base-icon--large': props.large,
    'base-icon--xlarge': props.xlarge,
    'base-icon--xxlarge': props.xxlarge,
    'base-icon--xxxlarge': props.xxxlarge,
    'base-icon--white': props.white,
    'base-icon--gray': props.gray,
    'base-icon--dark': props.dark,
    'base-icon--clickable': props.clickable,
  });

  return (
    <Suspense fallback={<span />}>
      <div className={classes} onClick={props.onClick} data-testid={props['data-testid']}>
        {props.loading ? <BaseLoaderSpinner isComponent /> : icons[props.icon]}
      </div>
    </Suspense>
  );
};

export default BaseIcon;
